module.exports = __webpack_public_path__ + "media/tingtung.b1a87b28.mp3";